import i18n from './i18n';
import config from './config';

let routes = {};

i18n.on('initialized', () => {
  routes = {
    en: {
      landing: '/',
      step: '/:step',
      step1: '/where-do-you-gain-your-energy-from',
      step2: '/how-do-you-approach-a-task',
      step3: '/how-do-you-decide-things',
      step4: '/what-is-your-attitude-to-life',
      results: '/results',
      result: '/results/:tab',
      animals: '/animals',
      animal: '/animals/:id/:tab',
      jobInformation: `${config.baseUrl.en}/job-information`,
      jobInformationJob: `${config.baseUrl.en}/job-information/:job`,
      jobInformationSubjects: `${config.baseUrl.en}/job-information/subjects`,
      jobInformationIndustry: `${config.baseUrl.en}/job-information/industry/:industry`,
      careerMatchQuiz: `${config.baseUrl.en}/career-match-quiz`
    },
    cy: {
      landing: '/',
      step: '/:step',
      step1: '/o-ble-ddaw-eich-egni',
      step2: '/sut-wyt-ti-n-bwrw-ati-i-wneud-tasg',
      step3: '/sut-ydych-chi-n-penderfynu-pethau',
      step4: '/beth-yw-eich-agwedd-at-fywyd',
      results: '/canlyniadau',
      result: '/canlyniadau/:tab',
      animals: '/anifeiliaid',
      animal: '/anifeiliaid/:id/:tab',
      jobInformation: `${config.baseUrl.cy}/gwybodaeth-am-swyddi`,
      jobInformationJob: `${config.baseUrl.cy}/gwybodaeth-am-swyddi/:job`,
      jobInformationSubjects: `${config.baseUrl.cy}/gwybodaeth-am-swyddi/pynciau`,
      jobInformationIndustry: `${config.baseUrl.cy}/gwybodaeth-am-swyddi/diwydiant/:industry`,
      careerMatchQuiz: `${config.baseUrl.cy}/cwis-paru-gyrfa`
    }
  }
});

export function route(name, parameters = null, language = i18n.language) {
  if (parameters) {
    return routes[language][name]
      .split('/')
      .map((fragment) => {
        return fragment.startsWith(':') ? parameters[fragment.substr(1)] : fragment;
      })
      .join('/');
  }
  return routes[language][name];
}

export function routeTranslated(name, parameters = null) {
  return route(name, parameters, i18n.language === 'en' ? 'cy' : 'en');
}
